import { faEye, faTrash, faVideo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function AllScheduleList(): JSX.Element {
  return (
    <div className="recentCall-table-container">
      <div className="component-card rounded mb-4">
        <div className="component-card-header d-flex align-items-center justify-content-between border">
          <div>All Schedule List</div>
        </div>
        <div className="component-card-body rounded-bottom border-start border-end border-bottom">
          <div className="row align-items-center justify-content-center  py-5 my-3 w-100">
            <h2 className="font-weight-normal">The list is empty</h2>
          </div>

        </div>
      </div>
    </div>
  )
}
